module.exports = __webpack_public_path__ + "img/40_7.4218f0b4.png";